export enum SuppliesQuoteRequestSource {
  StorefrontHeader = "storefront_header",
}
